import { render, staticRenderFns } from "./PreferenceList.vue?vue&type=template&id=bc3ccdac&scoped=true"
import script from "./PreferenceList.vue?vue&type=script&lang=js"
export * from "./PreferenceList.vue?vue&type=script&lang=js"
import style0 from "./PreferenceList.vue?vue&type=style&index=0&id=bc3ccdac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3ccdac",
  null
  
)

export default component.exports